export enum SortMethod {
  ALPHABETICAL = "alphabetical",
  LAST_UPDATED = "last_updated",
}

export enum SortOrder {
  ASC = "asc",
  DESC = "desc",
}
